const STORAGE_KEY = "theme";
const DARK = "dark";
const LIGHT = "light";

const COLOR_THEMES = [
  "psychedelic",
  "inverted-psychedelic",
  "neon-statement",
  "earthy-organic",
  "maximum-contrast",
  "inverted-bold",
  "cool-nocturne",
  "dark-glamour",
  "hot-pink-punk",
  "inverted-punk",
  "funk-gold",
  "blood-thunder",
  "neon-nightmare",
  "purple-reign",
  "tangerine-dream",
  "dark-orange-fire",
  "midnight-salmon",
  "burgundy-velvet",
  "hot-pink-mint",
  "purple-cyan-electric"
];

function getStoredTheme(): string | null {
  return localStorage.getItem(STORAGE_KEY);
}

function setStoredTheme(theme: string): void {
  localStorage.setItem(STORAGE_KEY, theme);
}

function applyTheme(theme: string): void {
  document.documentElement.setAttribute("data-theme", theme);
}

export function setLightTheme(): void {
  applyTheme(LIGHT);
  setStoredTheme(LIGHT);
}

export function setDarkTheme(): void {
  applyTheme(DARK);
  setStoredTheme(DARK);
}

export function setRandomTheme(): void {
  const randomIndex = Math.floor(Math.random() * COLOR_THEMES.length);
  const theme = COLOR_THEMES[randomIndex];
  applyTheme(theme);
  setStoredTheme(theme);
}

export default function themeToggle(): void {
  // Initialize theme from localStorage, default to light (brand preference)
  const stored = getStoredTheme();
  const theme = stored || LIGHT;
  applyTheme(theme);

  // Attach click handlers to theme buttons
  const toggleButton = document.querySelector("[data-theme-toggle]");
  if (toggleButton) {
    toggleButton.addEventListener("click", () => {
      const current =
        document.documentElement.getAttribute("data-theme") || LIGHT;
      if (current === LIGHT) {
        setDarkTheme();
      } else {
        setLightTheme();
      }
    });
  }

  const randomButton = document.querySelector("[data-random-theme]");
  if (randomButton) {
    randomButton.addEventListener("click", () => {
      setRandomTheme();
      // Add spinning class and remove after animation completes
      randomButton.classList.add("spinning");
      randomButton.addEventListener(
        "animationend",
        () => randomButton.classList.remove("spinning"),
        { once: true }
      );
    });
  }
}
